import { useEffect, useState } from "react";
import { fetchContactCommunications } from "./campaignBuilderApi";

export function ContactCommunicationsPanel({ contactId }: { contactId: string }) {
  const [rows, setRows] = useState<Record<string, unknown>[]>([]);

  useEffect(() => {
    if (!contactId) return;
    void fetchContactCommunications(contactId)
      .then((data) => setRows(data.results ?? []))
      .catch(() => setRows([]));
  }, [contactId]);

  return (
    <div className="contact-comms">
      <h4>Campaign communications</h4>
      {!rows.length ? <p className="hint">No campaign emails recorded yet.</p> : null}
      <ul>
        {rows.map((row) => (
          <li key={String(row.communication_id)}>
            {String(row.sent_at)} — {String(row.campaign_name ?? row.marketing_campaign_id)} /{" "}
            {String(row.step_name ?? row.step_id)} ({String(row.status)})
          </li>
        ))}
      </ul>
    </div>
  );
}
